import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const FamiliesPerIndigenousGroup = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Famílias por Povo Indígena'}
            horizontal={false}
            subtitles={
                chartData?.familiesPerIndigenousGroup?.map((item) => item.description) || []
            }
            values={chartData?.familiesPerIndigenousGroup?.map((item) => item.total  ||  0) || []}
        />
    );
};
